import SxSExtendedViewState from '../store/schema/SxSExtendedViewState';
import { SxSCustomization } from '../store/schema/SxSStore';
import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';

export const reloadReadingPaneAfterClosingSxS = action('reloadReadingPaneAfterClosingSxS');

export const onSxSChangeOrClose = action(
    'onSxSChangeOrClose',
    (selectedLinkId: string | null, isSelectedLinkReadOnly?: boolean) => ({
        selectedLinkId,
        isSelectedLinkReadOnly,
    })
);

export const showSxS = action(
    'showSxS',
    (
        customization: SxSCustomization,
        extendedViewState: SxSExtendedViewState,
        editState: {
            editAllowed: boolean;
            itemId: ClientItemId;
            isDraft: boolean;
        },
        selectedLinkId: string
    ) => ({
        customization,
        extendedViewState,
        editState,
        selectedLinkId,
    })
);

export const closeSxS = action('closeSxS');
